import { Add } from './Add';
import { Back } from './Back';
import { Button, defaultButtonStyles } from './Button';
import { Cancel } from './Cancel';
import { Dashboard } from './Dashboard';
import { Done } from './Done';
import { Logout } from './Logout';
import { PrimaryButton } from './themed/PrimaryButton';
import { SecondaryButton } from './themed/SecondaryButton';
import { TertiaryButton } from './themed/TertiaryButton';
import { Upload } from './Upload';

export const Buttons = {
  defaultButtonStyles,
  Add,
  Back,
  Button,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  Cancel,
  Dashboard,
  Done,
  Logout,
  Upload,
};
